import { getScrollTop, getSupportsPassive } from './utils'
import EventBus from './EventBus'
const supportsPassive = getSupportsPassive()

const initScrollEvent = () => {
  let lastScrollTopEmitted = null
  let lastScrollTop = null
  let direction = null
  let tempScrollTop = null

  const scrollCallback = () => {
    tempScrollTop = getScrollTop()
    if (tempScrollTop > lastScrollTop) {
      direction = 'down'
    } else {
      direction = 'up'
    }
    lastScrollTop = tempScrollTop
  }
  window.addEventListener('scroll', scrollCallback, supportsPassive ? { passive: true } : false)


  const onAnimationFrame = (timestamp) => {
    if (lastScrollTopEmitted === lastScrollTop) {
      window.requestAnimationFrame(onAnimationFrame)
      return
    }

    EventBus.emit('custom-scroll', { scrollTop: lastScrollTop, direction })
    lastScrollTopEmitted = lastScrollTop
    window.requestAnimationFrame(onAnimationFrame)
  }
  window.requestAnimationFrame(onAnimationFrame)
}

export default initScrollEvent